class MatchingCaps {
  constructor() {
    this.containers = document.querySelectorAll('.matching-caps');
    if (!this.containers.length) return;
    
    this.init();
  }
  
  init() {
    this.containers.forEach(container => {
      const checkboxes = container.querySelectorAll('.matching-caps__checkbox');
      const productForm = document.querySelector('product-form form');
      const sectionId = container.dataset.sectionId;
      
      if (!productForm) return;
      
      // Prevent duplicate initialization
      if (productForm.dataset.matchingCapsInitialized === 'true') return;
      productForm.dataset.matchingCapsInitialized = 'true';
      
      // Update product price on checkbox change
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          this.updateProductPrice(container);
        });
      });
      
      // Check cart on page load
      this.checkCartForMatchingItems(container);
      
      // Intercept form submission - ALWAYS, with capture to run before Dawn's handlers
      const submitHandler = (e) => {
        this.handleFormSubmit(e, container, checkboxes);
        return false;
      };
      productForm.addEventListener('submit', submitHandler, true); // Capture phase
      
      // Listen for variant changes
      if (window.variantChangeUnsubscriber) {
        window.variantChangeUnsubscriber();
      }
      
      window.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
        this.handleVariantChange(container);
      });
    });
  }
  
  updateProductPrice(container) {
    const priceData = container.querySelector('.matching-caps__price-data');
    const sectionId = priceData.dataset.sectionId;
    const priceContainer = document.querySelector(`#price-${sectionId}`);
    
    if (!priceContainer) return;
    
    const basePrice = parseInt(priceData.dataset.basePrice);
    const checkboxes = container.querySelectorAll('.matching-caps__checkbox:checked:not([disabled])');
    
    let totalAdded = 0;
    
    // Only add price for checked caps NOT already in cart
    checkboxes.forEach(checkbox => {
      if (checkbox.dataset.inCart !== 'true') {
        totalAdded += parseInt(checkbox.dataset.variantPrice);
      }
    });
    
    const newPrice = basePrice + totalAdded;
    
    // Detect currency format from existing price
    if (!this.moneyFormat) {
      const salePriceElement = priceContainer.querySelector('.price__sale .price-item--sale');
      const regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular');
      const sampleElement = salePriceElement || regularPriceElement;
      
      if (sampleElement) {
        const sampleText = sampleElement.textContent.trim();
        this.moneyFormat = this.detectMoneyFormat(sampleText);
      }
    }
    
    // Check if product is on sale (check for price--on-sale class on child .price element, not just element existence)
    const priceElement = priceContainer.querySelector('.price');
    const isOnSale = priceElement && priceElement.classList.contains('price--on-sale');
    const salePriceElement = priceContainer.querySelector('.price__sale .price-item--sale');
    if (isOnSale && salePriceElement) {
      // Product is on sale - update sale price
      salePriceElement.textContent = this.formatMoney(newPrice);
      
      // Update compare-at price (strikethrough)
      const compareAtElement = priceContainer.querySelector('.price__sale .price-item--regular');
      if (compareAtElement) {
        // Store original compare-at price on first run
        if (!priceData.dataset.originalCompareAt) {
          const originalCompareAtText = compareAtElement.textContent.trim();
          priceData.dataset.originalCompareAt = this.parsePrice(originalCompareAtText);
        }
        
        // Calculate compare-at addition using caps' original prices, not sale prices
        let compareAtAdded = 0;
        checkboxes.forEach(checkbox => {
          if (checkbox.dataset.inCart !== 'true') {
            const capCompareAt = checkbox.dataset.variantCompareAt && 
                                 checkbox.dataset.variantCompareAt !== '' && 
                                 checkbox.dataset.variantCompareAt !== '0'
              ? parseInt(checkbox.dataset.variantCompareAt) 
              : parseInt(checkbox.dataset.variantPrice);
            compareAtAdded += capCompareAt;
          }
        });
        
        const originalCompareAt = parseInt(priceData.dataset.originalCompareAt);
        const newCompareAt = originalCompareAt + compareAtAdded;
        compareAtElement.textContent = this.formatMoney(newCompareAt);
      }
      
      return;
    }
    
    // If no sale price, update regular price (for non-sale products)
    const regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular');
    if (regularPriceElement) {
      regularPriceElement.textContent = this.formatMoney(newPrice);
    }
  }
  
  detectMoneyFormat(priceText) {
    // Detect the format from existing price text and extract actual currency
    // e.g. "$24.50 AUD" -> extract "AUD"
    const currencyMatch = priceText.match(/\s([A-Z]{3})$/);
    if (currencyMatch) {
      this.currencyCode = currencyMatch[1]; // Store actual currency (AUD, USD, EUR, etc.)
      return 'with_currency';
    }
    return 'standard';
  }
  
  parsePrice(priceText) {
    // Extract numeric value from formatted price string
    // Remove currency symbols, commas, spaces
    const cleaned = priceText.replace(/[^0-9.]/g, '');
    const dollars = parseFloat(cleaned);
    return Math.round(dollars * 100); // Convert to cents
  }
  
  async checkCartForMatchingItems(container) {
    try {
      const response = await fetch('/cart.js?t=' + Date.now());
      const cart = await response.json();
      const checkboxes = container.querySelectorAll('.matching-caps__checkbox');
      
      checkboxes.forEach(checkbox => {
        const variantId = parseInt(checkbox.dataset.variantId);
        const existsInCart = cart.items.some(item => item.variant_id === variantId);
        
        if (existsInCart) {
          checkbox.checked = true;
          checkbox.disabled = true;  // Disable so can't uncheck
          checkbox.dataset.inCart = 'true';
          
          // Update text to show "in cart"
          const label = checkbox.nextElementSibling;
          label.classList.add('matching-caps__label--in-cart');
          const textSpan = label.querySelector('.matching-caps__text');
          const capType = checkbox.dataset.capType === 'cotton' ? 'Cotton Cap' : 'Bamboo Ninja';
          textSpan.innerHTML = `Matching ${capType} is in your cart`;
        }
      });
      
      this.updateProductPrice(container);
    } catch (error) {
      console.error('Error checking cart:', error);
    }
  }
  
  async handleFormSubmit(e, container, checkboxes) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    const productForm = e.target;
    const formData = new FormData(productForm);
    const mainVariantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity') || 1);
    
    // RE-CHECK CART to update checkbox states before adding
    try {
      const cartResponse = await fetch('/cart.js?t=' + Date.now());
      const cart = await cartResponse.json();
      
      // Update checkbox states based on current cart
      checkboxes.forEach(checkbox => {
        const variantId = parseInt(checkbox.dataset.variantId);
        const existsInCart = cart.items.some(item => item.variant_id === variantId);
        
        if (existsInCart) {
          checkbox.disabled = true;
          checkbox.dataset.inCart = 'true';
        } else {
          // Item was removed from cart - re-enable checkbox
          checkbox.disabled = false;
          checkbox.dataset.inCart = 'false';
          
          // Restore original text if it was changed
          const label = checkbox.nextElementSibling;
          label.classList.remove('matching-caps__label--in-cart');
          const textSpan = label.querySelector('.matching-caps__text');
          const originalText = textSpan.dataset.originalText;
          if (originalText) {
            textSpan.innerHTML = originalText;
          }
        }
      });
    } catch (error) {
      console.error('Error re-checking cart before add:', error);
    }
    
    // Build items to add: Sheila(s) with quantity from selector
    const itemsToAdd = [{
      id: mainVariantId,
      quantity: parseInt(quantity)  // Respects quantity selector
    }];
    
    // Add caps (only if checked and not disabled)
    checkboxes.forEach(checkbox => {
      if (checkbox.checked && !checkbox.disabled && checkbox.dataset.inCart !== 'true') {
        itemsToAdd.push({
          id: parseInt(checkbox.dataset.variantId),
          quantity: 1  // Caps always quantity 1
        });
      }
    });
    
    // Add all items to cart using FormData (like Dawn does)
    try {
      const submitButton = productForm.querySelector('[type="submit"]');
      submitButton.classList.add('loading');
      submitButton.setAttribute('aria-disabled', 'true');
      
      // Get cart notification/drawer
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      // Build FormData with all items
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      
      const addFormData = new FormData();
      
      // Add all items to FormData
      itemsToAdd.forEach((item, index) => {
        addFormData.append(`items[${index}][id]`, item.id);
        addFormData.append(`items[${index}][quantity]`, item.quantity);
      });
      
      // Append sections (like Dawn does)
      if (cart) {
        addFormData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        addFormData.append('sections_url', window.location.pathname);
      }
      
      config.body = addFormData;
      
      const response = await fetch(window.routes.cart_add_url, config);
      const result = await response.json();
      
      if (result.status) {
        throw new Error(result.description || 'Failed to add to cart');
      }
      
      // Mark items as in cart, disable, and update text
      checkboxes.forEach(checkbox => {
        if (checkbox.checked && !checkbox.disabled) {
          checkbox.dataset.inCart = 'true';
          checkbox.disabled = true;
          
          const label = checkbox.nextElementSibling;
          label.classList.add('matching-caps__label--in-cart');
          const textSpan = label.querySelector('.matching-caps__text');
          const capType = checkbox.dataset.capType === 'cotton' ? 'Cotton Cap' : 'Bamboo Ninja';
          textSpan.innerHTML = `Matching ${capType} is in your cart`;
        }
      });
      
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      
      // Multiple items were added - result.items is an array
      // Use the first item's key (the Sheila) for the notification
      if (cart && result.items && result.items.length > 0) {
        const mainItem = result.items[0]; // The Sheila
        const formattedResult = {
          ...result,
          key: mainItem.key, // Add the key property that renderContents expects
          id: mainItem.id,
          product_id: mainItem.product_id,
          variant_id: mainItem.variant_id
        };
        cart.renderContents(formattedResult);
      }
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      const submitButton = productForm.querySelector('[type="submit"]');
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      
      alert('There was an error adding items to cart. Please try again.');
    }
  }
  
  async handleVariantChange(container) {
    // Don't reload section - matching caps are product-level, not variant-level
    // Just update the base price for the new variant
    const priceData = container.querySelector('.matching-caps__price-data');
    
    // Get the new variant's price from the main price display
    const sectionId = priceData.dataset.sectionId;
    const priceContainer = document.querySelector(`#price-${sectionId}`);
    
    if (priceContainer) {
      const salePriceElement = priceContainer.querySelector('.price__sale .price-item--sale');
      const regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular');
      const currentPriceElement = salePriceElement || regularPriceElement;
      
      if (currentPriceElement) {
        const currentPriceText = currentPriceElement.textContent.trim();
        const newBasePrice = this.parsePrice(currentPriceText);
        priceData.dataset.basePrice = newBasePrice;
        
        // Clear the stored original compare-at price so it recalculates
        delete priceData.dataset.originalCompareAt;
        
        // Update displayed prices with new base
        this.updateProductPrice(container);
      }
    }
  }
  
  formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    
    // Use Shopify's formatMoney if available
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    
    // Fallback formatting with actual detected currency
    if (this.moneyFormat === 'with_currency' && this.currencyCode) {
      return `$${dollars} ${this.currencyCode}`;
    }
    return `$${dollars}`;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new MatchingCaps());
} else {
  new MatchingCaps();
}
